import { render, staticRenderFns } from "./BotaoParametroBusca.vue?vue&type=template&id=09e0a284&scoped=true"
import script from "./BotaoParametroBusca.vue?vue&type=script&lang=js"
export * from "./BotaoParametroBusca.vue?vue&type=script&lang=js"
import style0 from "./BotaoParametroBusca.vue?vue&type=style&index=0&id=09e0a284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0a284",
  null
  
)

export default component.exports